module.exports = __webpack_public_path__ + "static/img/bg5.dd2b925.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sk/bg5.png
// module id = z9bH
// module chunks = 16